export default "/images/Logo.png?e62213b8d49285c64a48c7a6cefd43e2";